import style from './NavIndicator.style';

export default function NavIndicator({ offset }) {
  return (
    <div css={ style } data-active={ offset } />
  );
};